<form [formGroup]="form" (ngSubmit)="submitForm()">
  <title mat-dialog-title>{{ 'account.dialogs.changeName' | t }}</title>

  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button type="button" color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button mat-button type="submit" color="success" [mtBasicSpinner]="isLoading">{{ 'common.done' | t }}</button>
  </mat-dialog-actions>
</form>
